import { render } from "./ActivateAccount.vue?vue&type=template&id=5206ab6b&scoped=true"
import script from "./ActivateAccount.vue?vue&type=script&lang=js"
export * from "./ActivateAccount.vue?vue&type=script&lang=js"

import "./ActivateAccount.vue?vue&type=style&index=0&id=5206ab6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5206ab6b"]])

export default __exports__